import { render, staticRenderFns } from "./AppAuditlogs.vue?vue&type=template&id=ade84e68&scoped=true&"
import script from "./AppAuditlogs.vue?vue&type=script&lang=js&"
export * from "./AppAuditlogs.vue?vue&type=script&lang=js&"
import style0 from "./AppAuditlogs.vue?vue&type=style&index=0&id=ade84e68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade84e68",
  null
  
)

export default component.exports